import React, { useState } from "react";

import { Button, Stack, TextField, Typography } from "@mui/material";
import { SelectAutocomplete } from "components/forms";

interface Props {
  title: string;
  options: Option[];
  state: Option[];
  onSubmit: (values: Option[]) => void;
  onCancel: () => void;
}

type Option = { id: number; title: string };

export const FilterAutocompletePrompt: React.FC<Props> = ({ title, options, state, onSubmit, onCancel }) => {
  const [selectedValues, setSelectedValues] = useState<Option[]>(state);

  return (
    <Stack sx={{ alignItems: "stretch", p: "30px", gap: "30px", maxWidth: "500px" }}>
      <Stack
        sx={{ borderBottom: "1px solid #dae0e2", pb: "5px" }}
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography sx={{ fontSize: "15px" }}>{title}</Typography>
        <Stack flexDirection="row">
          <Button sx={{ color: "#26A6AE" }} variant="text" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            sx={{ color: "#26A6AE", ":disabled": { backgroundColor: "#FFF", color: "#bac7ce" } }}
            variant="text"
            onClick={() => onSubmit(selectedValues)}
          >
            Save
          </Button>
        </Stack>
      </Stack>
      <SelectAutocomplete<Option, true>
        multiple
        disableCloseOnSelect
        selectAll
        limitTags={1}
        openOnFocus
        options={options}
        renderInput={(params) => <TextField {...params} label="Filters" />}
        sx={{ maxWidth: "300px", minWidth: "300px" }}
        value={selectedValues}
        setValue={(value) => setSelectedValues(value)}
        getOptionLabel={(option) => option.title}
        renderOption={(props, option) => <li {...props}>{option.title}</li>}
        compareParam={(option) => option.title}
      />
    </Stack>
  );
};
